import { html, type Html, Page } from 'rune-ts';
import klass from './CurationList.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { footer_links } from '../../components/cells/Footer/constant';
import { updateUrlParams } from '../../../../../modules/Util/S/Function/util';
import { Pagination, PaginationChangeEvent } from '../../components/cells/Pagination/Pagination';
import { CurationListItem } from '../../../features/Curation/type';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { ProductCardViewData } from '../../../features/ProductList/type';
import { FloatingButton_recent_product } from '../../components/cells/FloatingBox/FloatingButtons/FloatingButton_recent_product';
import { FloatingBox } from '../../components/cells/FloatingBox/FloatingBox';
import { TabListView } from '@services/MarppleShop/shared/components/cells/TabList/TabListView.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';
import { CardCurationView } from '@services/MarppleShop/renderApp/pages/Curation/components/CardCurationView.ts';

const PAGINATION_SIZE = 10;

const PAGINATION_SIZE_MOBILE = 5;

type Category = {
  id: number;
  name: string;
  count: number;
};

export type CurationListPageData = {
  current_page: number;
  total_page: number;
  total_count: number;
  categories: Category[];
  selected_category_id: string;
  curations: CurationListItem[];
  recent_product?: ProductCardViewData;
  layout_options: BaseLayoutOptions;
};

export class CurationListPage extends Page<CurationListPageData> {
  protected override template(data: CurationListPageData): Html {
    const { curations, current_page, total_page, layout_options } = data;
    const { is_mobile } = layout_options;

    const body = html` <div class="${klass.page_body}">
      <!--   타이틀   -->
      ${is_mobile
        ? html`<div>
            ${new TabListView({
              tabs: [
                {
                  tab_title: ET('mps2::section_title::section_tabs::popup_store'),
                  href: `/${ET.lang}/@/popup-store`,
                  selected: false,
                },
                {
                  tab_title: ET('mps2::section_title::section_tabs::curation'),
                  href: `/${ET.lang}/@/curations`,
                  selected: true,
                },
                {
                  tab_title: ET('mps2::section_title::section_tabs::creator_view'),
                  href: `/${ET.lang}/@/creator_views`,
                  selected: false,
                },
              ],
            })}
          </div>`
        : null}

      <div class="${klass.section}">
        ${is_mobile
          ? html`${curations.map(
              (curation) =>
                html`<article class="${klass.card_curation_wrapper}">
                  ${new CardCurationView({
                    device: 'Mobile',
                    layout: 'Detail',
                    ...curation,
                  })}
                </article>`,
            )}
            ${total_page > 1
              ? html`<div class="${klass.pagination_wrapper}">
                  ${new Pagination({
                    page: current_page,
                    size: PAGINATION_SIZE_MOBILE,
                    total: total_page,
                  })}
                </div>`
              : null}`
          : html`<div class="${klass.section_title}">
                <p class="${classes(klass.sub_copy_text, font('16_medium'))}">
                  ${ET('curation::curation_list::sub_copy_text')}
                </p>

                <span class="${classes(klass.main_copy_text, font('28_bold'))}"
                  >${ET('curation::curation_list::main_copy_text')}</span
                >
              </div>

              <main class="${klass.curation}">
                ${curations.map(
                  (curation) =>
                    new CardCurationView({
                      device: 'PC',
                      layout: 'Detail',
                      ...curation,
                    }),
                )}
              </main>

              ${total_page > 1
                ? new Pagination({
                    page: current_page,
                    size: PAGINATION_SIZE,
                    total: total_page,
                  })
                : null}`}
      </div>
    </div>`;

    return html`
      <div>
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            full_width: is_mobile,
            floating_box: {
              recent_product: FloatingButton_recent_product.makeProps(this.data.recent_product),
              async renderHook(view: FloatingBox) {
                await FloatingBox.refreshRecentProductFloatingButton(view);
              },
            },
            ...layout_options,
            selected_bottom_tab_idx: 2,
            has_bottom_tab_bar: true,
            layout_klass: klass.layout_klass,
            footer_klass: klass.footer,
          },
        )}
      </div>
    `;
  }

  override onMount() {
    super.onMount();

    this.delegate(PaginationChangeEvent, Pagination, function handleChangePage(e) {
      location.href = updateUrlParams(location.href, { page: e.detail.page });
    });
  }
}
